import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  AppBar,
  Box,
  Toolbar,
  Typography,
  Container,
  IconButton,
  Tooltip
} from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';

/**
 * Header component with navigation
 */
class Header extends React.Component {
  render() {
    return (
      <AppBar 
        position="sticky" 
        elevation={2}
        sx={{ 
          backgroundColor: '#6c0c46',
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
        }}
      >
        <Toolbar sx={{ px: { xs: 1, sm: 2 } }}>
          <Tooltip title="Go to Home" arrow>
            <IconButton
              component={RouterLink}
              to="/"
              edge="start"
              color="inherit"
              sx={{ 
                mr: { xs: 1, sm: 2 },
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  transform: 'scale(1.05)',
                },
                transition: 'all 0.2s ease-in-out'
              }}
            >
              <HomeIcon />
            </IconButton>
          </Tooltip>
          
          <Typography 
            variant="h6" 
            component="div" 
            sx={{ 
              flexGrow: 1,
              fontWeight: 600,
              color: 'white',
              fontSize: { xs: '1rem', sm: '1.25rem' },
              display: { xs: 'none', sm: 'block' }
            }}
          >
            Astrana Knowledge Wiki
          </Typography>
          
          {/* Mobile title - shorter version */}
          <Typography 
            variant="h6" 
            component="div" 
            sx={{ 
              flexGrow: 1,
              fontWeight: 600,
              color: 'white',
              fontSize: '1rem',
              display: { xs: 'block', sm: 'none' }
            }}
          >
            Astrana Wiki
          </Typography>
        </Toolbar>
      </AppBar>
    );
  }
}

export default Header;
